import type { MessageDescriptor } from '@atlassian/jira-intl';
import type { ThirdPartyFieldId } from '../../../constants/fields';
import type { ThirdPartyFieldMapping } from '../../../types';
import {
	ASANA_ASSIGNEE_FIELD_ID,
	ASANA_DESCRIPTION_FIELD_ID,
	ASANA_NAME_FIELD_ID,
	ASANA_SECTION_FIELD_ID,
	ASANA_DUE_ON_FIELD_ID,
	ASANA_START_DATE_FIELD_ID,
	ASANA_COLLABORATORS_FIELD_ID,
	ASANA_LIKES_FIELD_ID,
	ASANA_TAGS_FIELD_ID,
	ASANA_CREATED_BY_FIELD_ID,
} from './constants';
import messages from './messages';
import type { AsanaField } from './types';

type FormatMessage = (message: MessageDescriptor) => string;

export const getFieldNameForThirdPartyFieldId = (
	fieldId: ThirdPartyFieldId,
	formatMessage: FormatMessage,
) => {
	switch (fieldId) {
		case ASANA_ASSIGNEE_FIELD_ID:
			return formatMessage(messages.asanaAssignee);
		case ASANA_NAME_FIELD_ID:
			return formatMessage(messages.asanaName);
		case ASANA_SECTION_FIELD_ID:
			return formatMessage(messages.asanaSection);
		case ASANA_DESCRIPTION_FIELD_ID:
			return formatMessage(messages.asanaDescription);
		case ASANA_DUE_ON_FIELD_ID:
			return formatMessage(messages.asanaDueOn);
		case ASANA_START_DATE_FIELD_ID:
			return formatMessage(messages.asanaStartDate);
		case ASANA_COLLABORATORS_FIELD_ID:
			return formatMessage(messages.asanaCollaborators);
		case ASANA_LIKES_FIELD_ID:
			return formatMessage(messages.asanaLikes);
		case ASANA_TAGS_FIELD_ID:
			return formatMessage(messages.asanaTags);
		case ASANA_CREATED_BY_FIELD_ID:
			return formatMessage(messages.asanaCreatedBy);
		default:
			return '';
	}
};

export const sanitizeAsanaFieldNames =
	(formatMessage: FormatMessage) =>
	({ thirdPartyField, ...rest }: ThirdPartyFieldMapping<AsanaField>): ThirdPartyFieldMapping => ({
		...rest,
		thirdPartyField: {
			...thirdPartyField,
			fieldName: thirdPartyField.fieldName
				? thirdPartyField.fieldName
				: getFieldNameForThirdPartyFieldId(thirdPartyField.fieldId, formatMessage),
		},
	});
